import { useQuery } from 'react-query';
import moment from 'moment';
import request from '../../../../helpers/request';
import { createDefinedParams } from '../utils';
import { notificationsConfig as config } from '../constants';

const getNotifications = async ({ queryKey }) => {
  const [_, params] = queryKey;

  return await request.get(
    '/Notification',
    params,
    'При загрузке уведомлений произошла ошибка'
  );
};

export const createNotificationsKey = (params) => [
  'notifications',
  createDefinedParams(params),
];

export const createNotificationsWithModes = (notifications) => {
  if (notifications?.length) {
    const init = { modes: new Set(), unreadCount: 0, items: [] };

    const data = notifications.reduce((acc, notification) => {
      if (Boolean(config[notification.mode])) {
        const { mode, isNew } = notification;

        if (isNew) acc.unreadCount++;
        acc.modes.add(mode);
        acc.items.push(notification);
      }

      return acc;
    }, init);

    return {
      notifications: data.items.sort(
        (a, b) => moment(b.dateTime) - moment(a.dateTime)
      ),
      modes: [...data.modes],
      unreadCount: data.unreadCount,
    };
  }

  return null;
};

export const useNotifications = (params, options) => {
  return useQuery(createNotificationsKey(params), getNotifications, options);
};
